const getAddress = async (zipCode: string) => {
  const url = `https://viacep.com.br/ws/${zipCode}/json/`

  try {
    const response = await fetch(url)
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
  }
}

export { getAddress }
